import { Injectable } from '@angular/core';
import { HttpInterceptorService } from '../http-interceptor/http-interceptor.service';
import { catchError, filter, of, repeat, switchMap, take, throwError, timeout } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommandRequestsService {
  lastRequest: any;

  constructor(private _http: HttpInterceptorService) {}

  getResponsesByRequestID(requestID, stringify = true, waitForAnswer = false): Promise<any> {
    return new Promise((resolve, reject) => {
      this._http
        .get(`command-requests/${requestID}`)
        .pipe(
          switchMap((res) => of(this.handleReqResponse(res, stringify))),
          // If `waitForAnswer == true`, repeat the call until all the boxes have `timeAnswer`
          repeat({ delay: 1000 }),
          filter((res) => !waitForAnswer || res.Boxes.every((box) => box.timeAnswer !== null)),
          take(1),
          timeout({
            each: 20000,
            with: () => throwError(() => new Error('Timeout'))
          }),
          catchError((err) => throwError(() => err))
        )
        .subscribe({
          next: (res) => {
            res = this.handleReqResponse(res, stringify);
            this.lastRequest = res;
            resolve(res);
          },
          error: (err) => {
            reject(err);
          }
        });
    });
  }

  getCommandRequestBoxID(requestBoxID: number, stringify = true): Promise<any> {
    return new Promise((resolve, reject) => {
      this._http.get(`command-requests/by-command-request-box-id/${requestBoxID}`).subscribe({
        next: (res) => {
          const { CommandRequest, CanClickCustomer } = res;

          res = this.handleReqResponse({ ...CommandRequest, CanClickCustomer }, stringify);
          this.lastRequest = res;
          resolve(res);
        },
        error: (err) => {
          reject(err);
        }
      });
    });
  }

  getRequestsByCustomer(customerID: number, startIndex = 0, limit = 20) {
    return this._http.get(`command-requests/customer/${customerID}/${startIndex}/${limit}`);
  }

  handleReqResponse(res, stringify = true) {
    res.totalAnswers = this.calcAnswers(res.Boxes);
    if (stringify) {
      res.Boxes.map((box) => {
        if (box.answer && typeof box.answer === 'object') {
          box.answerObj = box.answer;
          // WTF this is stringified?
          box.answer = JSON.stringify(box.answer);
        }
        return box;
      });
    }

    if (typeof res.parameters === 'string') {
      try {
        res.parameters = JSON.parse(res.parameters);
      } catch {}
    }

    return res;
  }
  calcAnswers(boxes) {
    if (!boxes) return;
    if (!boxes.length) return 0;
    let answers = 0;
    boxes.forEach((box) => {
      if (box.answer) answers++;
    });

    return answers;
  }
  checkStatus(requestID): Promise<any> {
    return new Promise((resolve, reject) => {
      this.getResponsesByRequestID(requestID).then((res) => {
        for (let i = 0; i < res.Boxes.length; i++) {
          let box = res.Boxes[i];
          if (box.answerObj?.Result === 'boxNotConnected') {
            reject('CHARGER_IS_OFFLINE');
            break;
          }
          if (box.HasFailed) {
            //Failed
            reject(res.PK_CommandRequestID);
            break;
          }
          if (i === res.Boxes.length - 1) {
            resolve(true);
            //Success
          }
        }
      });
    });
  }
}
